import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AuthService } from '../../authentication/service/auth.service';
import { Router } from '@angular/router';
import { CognitoUtil } from '../../authentication/service/cognito.service';
import { SellerApiService } from '../service/seller-api.service';
import { ProfileUser } from '../../authentication/user';
import { FirebaseHelperService } from '../../core/firebase/firebase-helper.service';
import { GlobalEventsManager } from '../../app-global-events-manager';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-seller-header',
  templateUrl: './seller-header.component.html',
  styleUrls: ['./seller-header.component.scss']
})
export class SellerHeaderComponent implements OnInit {

  user: ProfileUser = new ProfileUser();
  // tslint:disable-next-line:no-inferrable-types
  browserequest: number = 0;
  isBrowseRequestNotification: boolean;
  unReadMessageCount: Array<any> = [];
  unReadMessageCoWorkerCount: Array<any> = [];
  public currentUserId: number = null;
  public currentSellerId: number = null;
  isMessageAvailable: boolean;
  isMessageAvailableCoworker: boolean;
  isSelectedActiveBorder: string;
  isEditableOptionEnable: boolean;
  version: string;
  constructor(private router: Router, public auth: AuthService,
    private cognitoService: CognitoUtil, private sellerService: SellerApiService,
    private firebaseHelperService: FirebaseHelperService,
    private globalEventsManager: GlobalEventsManager, private translate: TranslateService) {
    this.globalEventsManager.sendNotificationSellerNameEmitter.subscribe((mode) => { this.callNotificationObject(); });

    this.globalEventsManager.sendActiveRequestProjectIdArrayEmitter.subscribe((mode) => {
      if (mode.length > 0) {
        for (let index = 0; index < mode.length; index++) {
          this.unReadMessageCount.push({ 'projectid': mode[index], 'count': 0 });
          this.getLatestUnreadMessageCount(mode[index]);
        }
      }
    });

    this.globalEventsManager.sendReadMessageArrayEmitter.subscribe((mode) => {
      if (mode.length > 0) {
        this.unReadMessageCount = mode;
        this.isMessageAvailable = false;
         this.globalEventsManager.sendMessageArray(this.unReadMessageCount);
        this.isAvailableMessages();
      }
    });

    this.globalEventsManager.sendReadMessageCoWorkerArrayEmitter.subscribe((mode) => {
      if (mode.length > 0) {
        this.unReadMessageCoWorkerCount = mode;
        this.isMessageAvailableCoworker = false;
        this.globalEventsManager.sendMessageArrayCoWorker(this.unReadMessageCoWorkerCount);
        this.isAvailableMessagesCoworker();
      }
    });

    this.globalEventsManager.sendEnableEditScopeDetailsEmitter.subscribe((mode) => {
      this.isEditableOptionEnable = mode;
    });

    this.globalEventsManager.showBrowseRequestNotificationEmitter.subscribe((mode) => {
      this.isBrowseRequestNotification = mode;
    });

    this.globalEventsManager.sendHeaderActivateEmitter.subscribe((mode) => {
      this.isSelectedActiveBorder = mode;
    });


  }

  ngOnInit() {
    this.version = environment.VERSION;
    // tslint:disable-next-line:prefer-const
    let userDetails = this.cognitoService.getCurrentUser();
    if (userDetails != null) {
      // get User Details By username
      this.sellerService.getProfileDetails(userDetails.username).subscribe(res => {
        if (res != null) {
          this.user = res;
          this.currentUserId = res.user_id;
          this.currentSellerId = res.seller_id;
          localStorage.removeItem('yasoUserFirstName');
          localStorage.setItem('yasoUserFirstName', this.user.first_name);
        }
      }, err => {
        console.log(err);
      });
    }

    if (this.router.url.includes('safetybox')) {
      this.isSelectedActiveBorder = 'safetybox';
    }
    if (this.router.url.includes('browserequest')) {
      this.isSelectedActiveBorder = 'browserequest';
    }

    if (this.router.url.includes('manageprojects')) {
      this.isSelectedActiveBorder = 'manageprojects';
    }
  }

  switchLanguage(language: string) {
    this.translate.use(language);
}

  callNotificationObject() {
    // tslint:disable-next-line:prefer-const
    let userDetails = this.cognitoService.getCurrentUser();
    if (userDetails != null) {
      this.sellerService.getallNotificationDetails(userDetails.username).subscribe(res => {
        if (res != null) {
          this.browserequest = res.browse_request_project_count;
          if (this.browserequest > 0) {
            this.isBrowseRequestNotification = true;
          }
          for (let index = 0; index < res.agreed_project_ids.length; index++) {
            this.unReadMessageCount.push({ 'projectid': res.agreed_project_ids[index].project_id, 'count': 0 });
            this.unReadMessageCoWorkerCount.push({ 'projectid': res.agreed_project_ids[index].project_id, 'count': 0 });
            this.getLatestUnreadMessageCount(res.agreed_project_ids[index].project_id);
            this.getLatestUnreadMessageCountCoWorkers(res.agreed_project_ids[index].project_id);
          }
          for (let index = 0; index < res.accepted_project_request_ids.length; index++) {
            this.unReadMessageCount.push({ 'projectid': res.accepted_project_request_ids[index].project_id, 'count': 0 });
            this.getLatestUnreadMessageCount(res.accepted_project_request_ids[index].project_id);
          }
        }
      }, err => {
        console.log(err);
      });
    }
  }


  // Get the UnRead Message Count for each project
 async getLatestUnreadMessageCount(projectid: number) {
    await this.firebaseHelperService.getAllMessages(projectid, this.currentSellerId, this.currentUserId).subscribe(res => {
      this.firebaseHelperService.getLatestLogTime(projectid, this.currentSellerId, this.currentUserId).then(res1 => {
        if (res1.val()) {
          this.firebaseHelperService.getLatestUnReadMessages(projectid, this.currentSellerId, res1.val().lastReadTime).then(res2 => {
            if (res2.val()) {
              this.isMessageAvailable = false;
              this.unReadMessageCount.find(v => v.projectid === projectid).count = res2.numChildren();
              this.globalEventsManager.sendMessageArray(this.unReadMessageCount);
              this.isAvailableMessages();
            }
          });
        }
      });
    });
    // this.firebaseHelperService.getLatestLogTime(projectid,
    //   this.currentSellerId, this.currentUserId).subscribe(res => {
    //     if (res.length > 0) {
    //       this.getLatestUnreadMessageCountByLatest(projectid, res[0].payload.val());
    //     }
    //   });
  }

    // Get the UnRead Message Count for each project
   async getLatestUnreadMessageCountCoWorkers(projectid: number) {
      // this.firebaseHelperService.getLatestCoWorkerLogTime(projectid,
      //   this.currentSellerId, this.currentUserId).subscribe(res => {
      //     if (res.length > 0) {
      //       this.getLatestUnreadMessageCountByLatestCoWorker(projectid, res[0].payload.val());
      //     }
      //   });
      await this.firebaseHelperService.getAllCoWorkerMessages(projectid, this.currentSellerId).subscribe(res => {
        this.firebaseHelperService.getLatestCoWorkerLogTime(projectid, this.currentSellerId, this.currentUserId).then(res1 => {
          if (res1.val()) {
            this.firebaseHelperService.getLatestCoWorkerUnReadMessages(projectid,
              this.currentSellerId, res1.val().lastReadTime).then(res2 => {
              if (res2.val()) {
                this.isMessageAvailableCoworker = false;
                this.unReadMessageCoWorkerCount.find(v => v.projectid === projectid).count = res2.numChildren();
                this.globalEventsManager.sendMessageArrayCoWorker(this.unReadMessageCoWorkerCount);
                this.isAvailableMessagesCoworker();
              }
            });
          }
        });
      });
    }

  // using Logtime and ProjectId //  get the messages count
  // getLatestUnreadMessageCountByLatest(projectid, logtime) {
  // // tslint:disable-next-line:prefer-const
  // let logmodi =  moment(logtime).add(0.5, 'm').toDate();
  //   this.firebaseHelperService.getLatestUnReadMessages(projectid,
  //     this.currentSellerId, new Date(logmodi).getTime()).subscribe(res => {
  //       this.isMessageAvailable = false;
  //       this.unReadMessageCount.find(v => v.projectid === projectid).count = res.length;
  //       this.globalEventsManager.sendMessageArray(this.unReadMessageCount);
  //       this.isAvailableMessages();
  //     });
  // }


  // getLatestUnreadMessageCountByLatestCoWorker(projectid, logtime) {
  //   // tslint:disable-next-line:prefer-const
  //   let logmodi =  moment(logtime).add(0.5, 'm').toDate();
  //     this.firebaseHelperService.getLatestCoWorkerUnReadMessages(projectid,
  //       this.currentSellerId, new Date(logmodi).getTime()).subscribe(res => {
  //         this.isMessageAvailableCoworker = false;
  //         this.unReadMessageCoWorkerCount.find(v => v.projectid === projectid).count = res.length;
  //        this.globalEventsManager.sendMessageArrayCoWorker(this.unReadMessageCoWorkerCount);
  //         this.isAvailableMessagesCoworker();
  //       });
  //   }

  isAvailableMessages() {
    this.unReadMessageCount.filter(item => {
      if (item.count > 0) {
        this.isMessageAvailable = true;
        return;
      }
    });
  }

  isAvailableMessagesCoworker() {
    this.unReadMessageCoWorkerCount.filter(item => {
      if (item.count > 0) {
        this.isMessageAvailableCoworker = true;
        return;
      }
    });
  }


  private checkAuthentication() {
    Observable.fromPromise(this.auth.isAuthenticated())
      .map(isAuthed => {
        return isAuthed;
      });
  }

  callCommonFunction(url, value): void {
    if (this.isEditableOptionEnable) {
      this.globalEventsManager.sendopenConfirmationModal(true);
      return;
    }
    this.isSelectedActiveBorder = value;
    this.router.navigate([url]);
  }

}



// WEBPACK FOOTER //
// ./src/app/seller/seller-header/seller-header.component.ts